module.exports = __webpack_public_path__ + "static/media/customer-cremica.5e5d1d03.png";